import React, { useState } from "react";
import PropTypes from "prop-types";

import { Tooltip, Button } from "@mui/material";
import AddCircle from "@mui/icons-material/AddCircle";

import { CreateCaseActionDialog } from "components/CaseManagement/CaseForms/CreateCaseActionDialog";

export function AddActionButton(props) {
  const { caseId, addNewAction } = props;

  const [actionDialogVisible, setActionDialogVisible] = useState(false);

  const showActionDialog = () => {
    setActionDialogVisible(true);
  };

  return (
    <>
      <Tooltip
        title="Add a new action to the case"
        aria-label="Add Action Button tooltip"
      >
        <Button
          variant="outlined"
          color="primary"
          size="small"
          data-qa="CP-Button-Add-Action"
          aria-label="Add Action Button"
          onClick={showActionDialog}
          startIcon={<AddCircle />}
        >
          Add new action
        </Button>
      </Tooltip>
      {actionDialogVisible && (
        <CreateCaseActionDialog
          open={actionDialogVisible}
          setOpen={setActionDialogVisible}
          caseId={caseId}
          addNewAction={addNewAction}
        />
      )}
    </>
  );
}

AddActionButton.propTypes = {
  caseId: PropTypes.number.isRequired,
  addNewAction: PropTypes.func
};
